"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

exports.__esModule = true;
exports.ClickOutside = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Click outside behavior
 */
var ClickOutside = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(ClickOutside, _React$PureComponent);

  var _super = _createSuper(ClickOutside);

  function ClickOutside(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ClickOutside);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_boundEvents", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isInsideClick", function (event) {
      var _this$props = _this.props,
          rootRef = _this$props.rootRef,
          excludeClass = _this$props.excludeClass;
      var target = event.target;

      while (target) {
        // Same node
        if (rootRef.current === target) {
          return true;
        } // Contains an excluded class


        if (target.classList) {
          if (typeof excludeClass === 'string' && target.classList.contains(excludeClass)) {
            return true;
          }
        } // @ts-expect-error


        target = target.parentElement;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onClickOutside", function (event) {
      var onClickOutside = _this.props.onClickOutside;

      if (typeof onClickOutside === 'function' && !_this._isInsideClick(event)) {
        onClickOutside(event);
      }
    });
    _this._boundEvents = [];
    return _this;
  }
  /**
   * Register ClickOutside events
   */


  (0, _createClass2["default"])(ClickOutside, [{
    key: "_registerEvents",
    value: function _registerEvents() {
      var _this2 = this;

      var options = this.props.options;
      ['mouseup', 'touchend'].forEach(function (eventName) {
        document.addEventListener(eventName, _this2._onClickOutside, options);

        _this2._boundEvents.push(eventName);
      });
    }
    /**
     * Unregister ClickOutside events
     */

  }, {
    key: "_unregisterEvents",
    value: function _unregisterEvents() {
      var options = this.props.options;

      while (this._boundEvents.length > 0) {
        var eventName = this._boundEvents.pop();

        if (eventName) {
          document.removeEventListener(eventName, this._onClickOutside, options);
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.onClickOutside) {
        this._registerEvents();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.onClickOutside !== prevProps.onClickOutside) {
        if (this.props.onClickOutside) {
          this._registerEvents();
        } else {
          this._unregisterEvents();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._unregisterEvents();
    }
    /**
     * Check whether the click is inside the element or excluded
     * @param event - Click event
     */

    /**
     * Check whether the click is inside the element or excluded
     * @param event - Click event
     */
    // @ts-ignore

  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return ClickOutside;
}(React.PureComponent);

exports.ClickOutside = ClickOutside;
//# sourceMappingURL=ClickOutside.js.map